'use client';
import clsx from 'clsx';
import { OpenAPISelect, OpenAPISelectItem, useSelectState } from './OpenAPISelect';
import { createStateKey } from './utils';
export function OpenAPIMediaTypeExamplesSelector(props) {
    var method = props.method, path = props.path, renderers = props.renderers, selectIcon = props.selectIcon, blockKey = props.blockKey;
    if (!renderers[0]) {
        throw new Error('No renderers provided');
    }
    var stateKey = createStateKey('request-body-media-type', blockKey);
    var state = useSelectState(stateKey, renderers[0].mediaType);
    var selected = renderers.find(function (r) { return r.mediaType === state.key; }) || renderers[0];
    return (<div className="openapi-codesample-selectors">
            <MediaTypeSelector selectIcon={selectIcon} stateKey={stateKey} renderers={renderers}/>
            <ExamplesSelector selectIcon={selectIcon} method={method} path={path} renderer={selected}/>
        </div>);
}
function MediaTypeSelector(props) {
    var renderers = props.renderers, stateKey = props.stateKey, selectIcon = props.selectIcon;
    if (renderers.length < 2) {
        return null;
    }
    var items = renderers.map(function (renderer) { return ({
        key: renderer.mediaType,
        label: renderer.mediaType,
    }); });
    return (<OpenAPISelect className={clsx('openapi-select')} items={renderers.map(function (renderer) { return ({
            key: renderer.mediaType,
            label: renderer.mediaType,
        }); })} icon={selectIcon} stateKey={stateKey} placement="bottom start">
            {items.map(function (item) { return (<OpenAPISelectItem key={item.key} id={item.key} value={item}>
                    {item.label}
                </OpenAPISelectItem>); })}
        </OpenAPISelect>);
}
function ExamplesSelector(props) {
    var method = props.method, path = props.path, renderer = props.renderer, selectIcon = props.selectIcon;
    if (renderer.examples.length < 2) {
        return null;
    }
    var items = renderer.examples.map(function (example, index) { return ({
        key: index,
        label: example.example.summary || "Example ".concat(index + 1),
    }); });
    return (<OpenAPISelect items={items} icon={selectIcon} stateKey={"media-type-sample-".concat(renderer.mediaType, "-").concat(method, "-").concat(path)} placement="bottom start">
            {items.map(function (item) { return (<OpenAPISelectItem key={item.key} id={item.key} value={item}>
                    {item.label}
                </OpenAPISelectItem>); })}
        </OpenAPISelect>);
}
export function OpenAPIMediaTypeExamplesBody(props) {
    var _a;
    var renderers = props.renderers, method = props.method, path = props.path, blockKey = props.blockKey;
    if (!renderers[0]) {
        throw new Error('No renderers provided');
    }
    var mediaTypeState = useSelectState(createStateKey('request-body-media-type', blockKey), renderers[0].mediaType);
    var selected = (_a = renderers.find(function (r) { return r.mediaType === mediaTypeState.key; })) !== null && _a !== void 0 ? _a : renderers[0];
    if (selected.examples.length === 0) {
        return selected.element;
    }
    return <ExamplesBody method={method} path={path} renderer={selected}/>;
}
function ExamplesBody(props) {
    var _a;
    var method = props.method, path = props.path, renderer = props.renderer;
    var exampleState = useSelectState("media-type-sample-".concat(renderer.mediaType, "-").concat(method, "-").concat(path), renderer.mediaType);
    var example = (_a = renderer.examples[Number(exampleState.key)]) !== null && _a !== void 0 ? _a : renderer.examples[0];
    if (!example) {
        throw new Error("No example found for key ".concat(exampleState.key));
    }
    return example.element;
}
